// URL Hiding Utility
// This utility completely hides page URLs by manipulating browser history
// Maintains fixed URL: domain.com/speedtech

let currentRoute = null;
let navigationHistory = [];
const ROUTE_STORAGE_KEY = 'speedtech_current_route';
const HISTORY_STORAGE_KEY = 'speedtech_navigation_history';

export const hideUrl = () => {
  try {
    const baseUrl = window.location.origin;
    window.history.replaceState(null, '', baseUrl);
  } catch (error) {
    console.warn('Could not hide URL:', error);
  }
};

export const saveCurrentRoute = (routeName, params = {}, query = {}) => {
  currentRoute = { name: routeName, params, query };
  localStorage.setItem(ROUTE_STORAGE_KEY, JSON.stringify(currentRoute));
  
  // Add to navigation history (avoid duplicates)
  const routeKey = `${routeName}_${JSON.stringify(params)}_${JSON.stringify(query)}`;
  const lastRoute = navigationHistory[navigationHistory.length - 1];
  const lastRouteKey = lastRoute ? `${lastRoute.name}_${JSON.stringify(lastRoute.params)}_${JSON.stringify(lastRoute.query)}` : '';
  
  if (routeKey !== lastRouteKey) {
    navigationHistory.push({ name: routeName, params, query });
    // Keep only last 10 routes to prevent memory issues
    if (navigationHistory.length > 10) {
      navigationHistory = navigationHistory.slice(-10);
    }
    localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(navigationHistory));
  }
};

export const getSavedRoute = () => {
  try {
    const saved = localStorage.getItem(ROUTE_STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.warn('Could not get saved route:', error);
    return null;
  }
};

export const navigateWithoutUrl = (router, routeName, params = {}, query = {}) => {
  // Store current route info
  saveCurrentRoute(routeName, params, query);
  
  // Navigate using Vue Router
  router.push({ name: routeName, params, query });
  
  // Hide URL after navigation
  setTimeout(hideUrl, 0);
};

export const getCurrentRoute = () => {
  return currentRoute;
};

export const getNavigationHistory = () => {
  try {
    const saved = localStorage.getItem(HISTORY_STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    console.warn('Could not get navigation history:', error);
    return [];
  }
};

export const goBack = (router) => {
  const history = getNavigationHistory();
  if (history.length > 1) {
    // Remove current route and get previous one
    history.pop(); // Remove current
    const previousRoute = history[history.length - 1];
    
    if (previousRoute) {
      // Update history
      localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(history));
      
      // Navigate to previous route
      router.push({
        name: previousRoute.name,
        params: previousRoute.params || {},
        query: previousRoute.query || {}
      });
      
      return true;
    }
  }
  return false;
};

// Initialize URL hiding on page load
export const initUrlHiding = (router) => {
  // Load navigation history
  navigationHistory = getNavigationHistory();
  
  // Hide URL on initial load
  setTimeout(hideUrl, 0);
  
  // Hide URL when user tries to navigate back/forward
  window.addEventListener('popstate', () => {
    setTimeout(hideUrl, 0);
  });
  
  // Hide URL when page becomes visible (tab switching)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      setTimeout(hideUrl, 0);
    }
  });
};